'use client';

import React, { useState } from 'react';
import { AppRouterCacheProvider } from '@mui/material-nextjs/v14-appRouter';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export function WidgetProviders({ children }: { children: React.ReactNode }) {
    const [queryClient] = useState(() => new QueryClient());

    // The emotion cache provider streams MUI's styles with the SSR HTML (mirrors the main
    // app's Providers); without it MUI icons insert their styles at hydration and the tree
    // fails to hydrate.
    return (
        <AppRouterCacheProvider>
            <NuqsAdapter>
                <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
            </NuqsAdapter>
        </AppRouterCacheProvider>
    );
}
